import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Component, forwardRef, Host, Input, Optional, SkipSelf, ViewEncapsulation} from '@angular/core';

import {MatDatepicker} from '@angular/material/datepicker';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import * as moment from 'moment';

import {DatepickerComponent} from '../datepicker';

@Component({
    selector: 'app-year-datepicker',
    templateUrl: './year-datepicker.component.html',
    styleUrls: ['./year-datepicker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YearDatepickerComponent),
            multi: true
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE]
        },
        {
            provide: MAT_DATE_FORMATS, useValue: {
                parse: {
                    dateInput: 'YYYY',
                },
                display: {
                    dateInput: 'YYYY',
                    monthYearLabel: 'YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'YYYY',
                },
            }
        },
    ],
    encapsulation: ViewEncapsulation.None
})
export class YearDatepickerComponent extends DatepickerComponent {
    @Input() public disabled: boolean;
    @Input() public outlined: boolean;

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);
    }

    protected setDate(value: moment.Moment): string {
        return value.utc(true).toISOString();
    }

    yearHandler($event, datepicker: MatDatepicker<any>){
        const date = $event.year().toString();

        this.onChange(date);
        super.writeValue(date);

        datepicker.close();
    }

    openDatepicker(datepicker: MatDatepicker<moment.Moment>): void {
        datepicker.opened = !datepicker.opened;
    }
}
